module.exports = __webpack_public_path__ + "img/optimized-physical-asset-utilization.af363f4b.svg";